import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {MarkCustomerAsVulnerableModel} from '../../../models/mark-customer-as-vulnerable-model';


@Component({
  selector: 'app-mark-vulnerable-dialog',
  templateUrl: './mark-vulnerable-dialog.component.html',
  styleUrls: ['./mark-vulnerable-dialog.component.css']
})
export class MarkVulnerableDialogComponent implements OnInit {

  public title = 'Mark customer as vulnerable';
  public text = 'Are you sure want to mark this customer as vulnerable?';

  public reason: string;

  constructor(
    public dialogRef: MatDialogRef<MarkVulnerableDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: MarkCustomerAsVulnerableModel
  ) { }

  ngOnInit(): void {
  }

  onOkClick(): void {

    const model = new MarkCustomerAsVulnerableModel();model.reason = this.reason;

    this.dialogRef.close(model);
  }

  onCancelClick(): void {
    this.dialogRef.close();
  }

}
